// extracted by mini-css-extract-plugin
export default {"container":"modal_scrollable_body-module__container--1FdZq"};